const key = 'i18nextLng';

export const setLanguage = language => {
  return localStorage.setItem(key, language);
};

export const getLanguage = () => {
  return localStorage.getItem(key) || 'en';
};
